module.exports = __webpack_public_path__ + "img/emprevo.15f9126f.png";